import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { SITE } from '../config/site';

const QUICK = [
  { id: 'horario', label: 'Horario' },
  { id: 'envio', label: 'Envíos' },
  { id: 'ubicacion', label: 'Ubicación' },
  { id: 'invima', label: 'INVIMA' },
  { id: 'pedido', label: 'Hacer pedido' },
];

function replyFor(text) {
  const t = text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  if (/hola|buenas|hey|oli/.test(t)) {
    return `¡Hola! Soy Bella, tu asistente de ${SITE.name} 💕 ¿En qué te ayudo? Puedes preguntarme por horario, envíos, ubicación o productos.`;
  }
  if (/horario|hora|abren|cierran|abierto/.test(t)) {
    return `Estamos abiertos: ${SITE.hours}.`;
  }
  if (/envio|envios|envio|entrega|domicilio|nacional/.test(t)) {
    return `Sí hacemos envíos nacionales desde Medellín. Cuéntame tu ciudad por WhatsApp y te damos tiempo y costo aproximado.`;
  }
  if (/ubicacion|donde|direccion|tienda fisica|llegar|mapa/.test(t)) {
    return `Estamos en ${SITE.address}.`;
  }
  if (/invima|registro|sanitario|seguro|original/.test(t)) {
    return `Sí: manejamos productos de belleza importados con registro INVIMA. Calidad y confianza para tu negocio o uso personal.`;
  }
  if (/precio|cuesta|vale|cotiz/.test(t)) {
    return `Los precios están en la tienda online. También puedes escribirnos por WhatsApp y te ayudamos a armar tu pedido.`;
  }
  if (/pedido|comprar|whatsapp|asesor|hablar/.test(t)) {
    return `Perfecto. Puedes agregar al carrito en la web o escribirnos directo por WhatsApp para asesoría personalizada.`;
  }
  if (/uña|manicure|esmalte|gel/.test(t)) {
    return `Tenemos una línea completa de uñas. Entra a Tienda → Uñas, o te paso el catálogo por WhatsApp.`;
  }
  if (/maquillaje|labial|base|sombra/.test(t)) {
    return `En Maquillaje encontrarás bases, labiales, brochas y más. ¿Buscas algo en concreto?`;
  }
  if (/gracias|chao|adios/.test(t)) {
    return `¡Con gusto! Cuando quieras, aquí estoy. Que brilles hoy.`;
  }
  return `No estoy segura de eso, pero un asesor humano te responde al instante por WhatsApp. ¿Te conecto?`;
}

export default function ChatBot() {
  const [open, setOpen] = useState(false);
  const [input, setInput] = useState('');
  const [messages, setMessages] = useState([
    {
      from: 'bot',
      text: `¡Hola! Soy Bella ✨ Te ayudo con horario, envíos, ubicación y pedidos de ${SITE.name}.`,
    },
  ]);
  const endRef = useRef(null);

  useEffect(() => {
    if (open) endRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, open]);

  const waHref = useMemo(
    () => `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent('Hola ¡Oh! Belleza, vengo del chat de la web.')}`,
    []
  );

  function pushBot(text) {
    setMessages((m) => [...m, { from: 'bot', text }]);
  }

  function send(text) {
    const value = (text || input).trim();
    if (!value) return;
    setInput('');
    setMessages((m) => [...m, { from: 'user', text: value }]);
    window.setTimeout(() => pushBot(replyFor(value)), 380);
  }

  function onQuick(id) {
    const map = {
      horario: '¿Cuál es el horario?',
      envio: '¿Hacen envíos?',
      ubicacion: '¿Dónde están ubicados?',
      invima: '¿Los productos tienen INVIMA?',
      pedido: 'Quiero hacer un pedido',
    };
    send(map[id]);
  }

  return (
    <div className={`chatbot ${open ? 'open' : ''}`}>
      {open ? (
        <div className="chatbot-panel" role="dialog" aria-label="Chat Bella">
          <header className="chatbot-head">
            <div className="chatbot-avatar" aria-hidden>
              <img src="/brand/logo-oh-belleza.png" alt="" />
            </div>
            <div>
              <strong>Bella</strong>
              <span>Asistente ¡Oh! Belleza</span>
            </div>
            <button type="button" className="chatbot-close" onClick={() => setOpen(false)} aria-label="Cerrar chat">
              ×
            </button>
          </header>

          <div className="chatbot-messages">
            {messages.map((m, i) => (
              <div key={`${m.from}-${i}`} className={`chatbot-bubble ${m.from}`}>
                {m.text}
              </div>
            ))}
            <div ref={endRef} />
          </div>

          <div className="chatbot-quick">
            {QUICK.map((q) => (
              <button key={q.id} type="button" onClick={() => onQuick(q.id)}>
                {q.label}
              </button>
            ))}
          </div>

          <form
            className="chatbot-form"
            onSubmit={(e) => {
              e.preventDefault();
              send();
            }}
          >
            <input
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder="Escribe tu pregunta…"
              aria-label="Mensaje"
            />
            <button type="submit" aria-label="Enviar">
              →
            </button>
          </form>

          <a className="chatbot-wa" href={waHref} target="_blank" rel="noreferrer">
            Hablar con un asesor en WhatsApp
          </a>
        </div>
      ) : null}

      <button
        type="button"
        className="chatbot-fab"
        onClick={() => setOpen((v) => !v)}
        aria-label={open ? 'Cerrar chat' : 'Abrir chat con Bella'}
      >
        {open ? '×' : '💬'}
        {!open ? <em>Bella</em> : null}
      </button>
    </div>
  );
}
